// import api from './api';
// import CollectionsService from './collectionsService';

// class CreditService {
//   /**
//    * Get customers with outstanding credits/collections
//    * @param {Object} params - Query parameters
//    * @returns {Promise} Formatted credit data
//    */
//   static async getCustomersWithCredits(params = {}) {
//     try {
//       // Add default filter to get only credit collections
//       const collectionParams = {
//         ...params,
//         typ: 'CREDIT', // Filter by credit type
//         status: 'PENDING', // Get pending collections
//       };

//       console.log('Fetching with params:', collectionParams); // Debug
      
//       // Use CollectionsService to fetch collections data
//       const apiResponse = await CollectionsService.getCollections(collectionParams);
      
//       console.log('API Response received:', apiResponse); // Debug
      
//       // Format the data - handle different response formats
//       return this.formatCreditData(apiResponse);
//     } catch (error) {
//       console.error('Error fetching customers with credits:', error);
      
//       // Check if it's already a formatted error
//       if (error.success !== undefined) {
//         throw error;
//       }
      
//       // Format the error
//       throw CollectionsService.handleError(error);
//     }
//   }

//   /**
//    * Format collections data into credit/balance format
//    * @param {Object} apiResponse - Raw API response
//    * @returns {Object} Formatted credit data
//    */
//   static formatCreditData(apiResponse) {
//   console.log('Formatting data from:', apiResponse); // Debug
  
//   let collectionsArray = [];
  
//   // CASE 1: API returns { success: false, data: [...] } - YOUR CURRENT FORMAT
//   if (apiResponse && apiResponse.success === false && Array.isArray(apiResponse.data)) {
//     console.log('Processing success:false format');
//     collectionsArray = apiResponse.data;
//   }
//   // CASE 2: API returns { success: true, data: [...] }
//   else if (apiResponse && apiResponse.success === true && Array.isArray(apiResponse.data)) {
//     console.log('Processing success:true format');
//     collectionsArray = apiResponse.data;
//   }
//   // CASE 3: Direct array response
//   else if (Array.isArray(apiResponse)) {
//     console.log('Processing direct array format');
//     collectionsArray = apiResponse;
//   }
//   // CASE 4: Something else
//   else {
//     console.warn('Unknown response format:', apiResponse);
//     return {
//       success: true,
//       message: 'No data available or invalid format',
//       data: { customers: [], routeSummary: {} }
//     };
//   }
  
//   console.log('Extracted collections:', collectionsArray);
  
//   if (!collectionsArray.length) {
//     return {
//       success: true,
//       message: 'No outstanding credits found',
//       data: { customers: [], routeSummary: {} }
//     };
//   }

//   // Don't group by customer - return each collection as a separate "customer" record
//   const customers = collectionsArray.map(collection => ({
//     id: collection.id,
//     collectionId: collection.id, // Keep collectionId for reference
//     name: `Collection ${collection.code}`,
//     code: collection.code,
//     amount: collection.amount, // This is the actual amount field
//     outstandingBalance: collection.amount, // For compatibility with existing code
//     creditId: collection.creditId,
//     salePersonId: collection.salePersonId,
//     status: collection.status,
//     type: collection.typ,
//     createdAt: collection.createdAt,
//     // Include all original fields for reference
//     ...collection
//   }));
  
//   // Calculate summary
//   const totalOutstanding = customers.reduce((sum, customer) => sum + (customer.amount || 0), 0);
  
//   const routeSummary = {
//     totalOutstanding: totalOutstanding,
//     customerCount: customers.length,
//     collectionCount: collectionsArray.length,
//     averageBalance: customers.length > 0 ? totalOutstanding / customers.length : 0
//   };

//   return {
//     success: true,
//     message: `Found ${collectionsArray.length} credit collection(s) totaling ${totalOutstanding}`,
//     data: {
//       customers, // Each collection is now a separate customer record
//       routeSummary,
//       rawCollections: collectionsArray
//     }
//   };
// }
//   /**
//    * Alternative: Get collections directly without customer grouping
//    */
//   static async getCollectionsDirect(params = {}) {
//     try {
//       const collectionParams = {
//         ...params,
//         typ: 'CREDIT',
//         status: 'PENDING'
//       };

//       const apiResponse = await CollectionsService.getCollections(collectionParams);
      
//       let collectionsArray = [];
      
//       if (apiResponse && apiResponse.success === false && Array.isArray(apiResponse.data)) {
//         collectionsArray = apiResponse.data;
//       } else if (apiResponse && Array.isArray(apiResponse.data)) {
//         collectionsArray = apiResponse.data;
//       } else if (Array.isArray(apiResponse)) {
//         collectionsArray = apiResponse;
//       }
      
//       return {
//         success: true,
//         message: `Found ${collectionsArray.length} collections`,
//         data: {
//           collections: collectionsArray,
//           totalAmount: collectionsArray.reduce((sum, col) => sum + (col.amount || 0), 0)
//         }
//       };
//     } catch (error) {
//       console.error('Error getting collections:', error);
//       throw CollectionsService.handleError(error);
//     }
//   }

//   /**
//    * Process credit payment
//    */
//   static async processCreditPayment(paymentData) {
//     try {
//       console.log('Processing payment:', paymentData);
      
//       const response = await api.post('/credits/pay-balance', paymentData);
      
//       // Update collection status if payment successful
//       if (response.data.success && paymentData.collectionId) {
//         try {
//           await CollectionsService.updateStatus(paymentData.collectionId, 'PAID');
//           console.log(`Updated collection ${paymentData.collectionId} to PAID`);
//         } catch (updateError) {
//           console.warn('Status update failed:', updateError);
//         }
//       }
      
//       return response.data;
//     } catch (error) {
//       console.error('Payment error:', error);
//       throw CollectionsService.handleError(error);
//     }
//   }

//   /**
//    * Error handling
//    */
//   static handleError(error) {
//     return CollectionsService.handleError(error);
//   }
// }

// export default CreditService;


import api from './api';
import CollectionsService from './collectionsService';

class CreditService {
  /**
   * Get customers with outstanding credits/collections
   * @param {Object} params - Query parameters
   * @returns {Promise} Formatted credit data
   */
  static async getCustomersWithCredits(params = {}) {
    try {
      // Add default filter to get only credit collections
      const collectionParams = {
        ...params,
        typ: 'CREDIT', // Filter by credit type
        status: 'PENDING', // Get pending collections
      };

      console.log('Fetching with params:', collectionParams); // Debug
      
      // Use CollectionsService to fetch collections data
      const apiResponse = await CollectionsService.getCollections(collectionParams);
      
      console.log('API Response received:', apiResponse); // Debug
      
      // Format the data - handle different response formats
      return this.formatCreditData(apiResponse);
    } catch (error) {
      console.error('Error fetching customers with credits:', error);
      
      // Check if it's already a formatted error
      if (error.success !== undefined) {
        throw error;
      }
      
      // Format the error
      throw CollectionsService.handleError(error);
    }
  }

  /**
   * Format collections data into credit/balance format
   * @param {Object} apiResponse - Raw API response
   * @returns {Object} Formatted credit data
   */
  static formatCreditData(apiResponse) {
  console.log('Formatting data from:', apiResponse); // Debug
  
  let collectionsArray = [];
  
  // CASE 1: API returns { success: false, data: [...] } - YOUR CURRENT FORMAT
  if (apiResponse && apiResponse.success === false && Array.isArray(apiResponse.data)) {
    console.log('Processing success:false format');
    collectionsArray = apiResponse.data;
  }
  // CASE 2: API returns { success: true, data: [...] }
  else if (apiResponse && apiResponse.success === true && Array.isArray(apiResponse.data)) {
    console.log('Processing success:true format');
    collectionsArray = apiResponse.data;
  }
  // CASE 3: Direct array response
  else if (Array.isArray(apiResponse)) {
    console.log('Processing direct array format');
    collectionsArray = apiResponse;
  }
  // CASE 4: Something else
  else {
    console.warn('Unknown response format:', apiResponse);
    return {
      success: true,
      message: 'No data available or invalid format',
      data: { customers: [], routeSummary: {} }
    };
  }
  
  console.log('Extracted collections:', collectionsArray);
  
  if (!collectionsArray.length) {
    return {
      success: true,
      message: 'No outstanding credits found',
      data: { customers: [], routeSummary: {} }
    };
  }

  // Don't group by customer - return each collection as a separate "customer" record
  const customers = collectionsArray.map(collection => ({
    id: collection.id,
    collectionId: collection.id, // Keep collectionId for reference
    name: `Collection ${collection.code}`,
    code: collection.code,
    amount: collection.amount, // This is the actual amount field
    outstandingBalance: collection.amount, // For compatibility with existing code
    creditId: collection.creditId,
    salePersonId: collection.salePersonId,
    status: collection.status,
    type: collection.typ,
    createdAt: collection.createdAt,
    // Include all original fields for reference
    ...collection
  }));
  
  // Calculate summary
  const totalOutstanding = customers.reduce((sum, customer) => sum + (customer.amount || 0), 0);
  
  const routeSummary = {
    totalOutstanding: totalOutstanding,
    customerCount: customers.length,
    collectionCount: collectionsArray.length,
    averageBalance: customers.length > 0 ? totalOutstanding / customers.length : 0
  };

  return {
    success: true,
    message: `Found ${collectionsArray.length} credit collection(s) totaling ${totalOutstanding}`,
    data: {
      customers, // Each collection is now a separate customer record
      routeSummary,
      rawCollections: collectionsArray
    }
  };
}
  /**
   * Alternative: Get collections directly without customer grouping
   */
  // static async getCollectionsDirect(params = {}) {
  //   try {
  //     const collectionParams = {
  //       ...params,
  //       typ: 'CREDIT',
  //       status: 'PENDING'
  //     };

  //     const apiResponse = await CollectionsService.getCollections(collectionParams);
      
  //     let collectionsArray = [];
      
  //     if (apiResponse && apiResponse.success === false && Array.isArray(apiResponse.data)) {
  //       collectionsArray = apiResponse.data;
  //     } else if (apiResponse && Array.isArray(apiResponse.data)) {
  //       collectionsArray = apiResponse.data;
  //     } else if (Array.isArray(apiResponse)) {
  //       collectionsArray = apiResponse;
  //     }
      
  //     return {
  //       success: true,
  //       message: `Found ${collectionsArray.length} collections`,
  //       data: {
  //         collections: collectionsArray,
  //         totalAmount: collectionsArray.reduce((sum, col) => sum + (col.amount || 0), 0)
  //       }
  //     };
  //   } catch (error) {
  //     console.error('Error getting collections:', error);
  //     throw CollectionsService.handleError(error);
  //   }
  // }
/**
 * Alternative: Get collections directly without customer grouping
 */
static async getCollectionsDirect(params = {}) {
  try {
    const collectionParams = {
      ...params,
      typ: 'CREDIT',
      // Don't filter by status here to get all collections
      // status: 'PENDING' // Removed to get all statuses
    };

    const apiResponse = await CollectionsService.getCollections(collectionParams);
    
    let collectionsArray = [];
    
    if (apiResponse && apiResponse.success === true && Array.isArray(apiResponse.data)) {
      collectionsArray = apiResponse.data;
    } else if (apiResponse && apiResponse.success === false && Array.isArray(apiResponse.data)) {
      collectionsArray = apiResponse.data;
    } else if (Array.isArray(apiResponse)) {
      collectionsArray = apiResponse;
    }
    
    // Calculate summary statistics by status
    const paidCollections = collectionsArray.filter(col => col.status === 'PAID');
    const partiallyPaidCollections = collectionsArray.filter(col => col.status === 'PARTIALLY_PAID');
    const pendingCollections = collectionsArray.filter(col => col.status === 'PENDING');
    
    const totalAmount = collectionsArray.reduce((sum, col) => sum + (col.amount || 0), 0);
    const totalPaidAmount = paidCollections.reduce((sum, col) => sum + (col.amount || 0), 0);
    const totalPartiallyPaidAmount = partiallyPaidCollections.reduce((sum, col) => sum + (col.amount || 0), 0);
    const totalPendingAmount = pendingCollections.reduce((sum, col) => sum + (col.amount || 0), 0);
    
    return {
      success: true,
      message: `Found ${collectionsArray.length} credit collection(s)`,
      data: {
        collections: collectionsArray.map(collection => ({
          id: collection.id,
          typ: collection.typ,
          code: collection.code,
          amount: collection.amount,
          status: collection.status,
          createdAt: collection.createdAt,
          credit: collection.credit ? {
            id: collection.credit.id,
            amount: collection.credit.amount,
            remainingAmount: collection.credit.remainingAmount,
            status: collection.credit.status,
            customer: collection.credit.customer ? {
              id: collection.credit.customer.id,
              name: collection.credit.customer.name
            } : null
          } : null
        })),
        summary: {
          totalCollections: collectionsArray.length,
          totalAmount: totalAmount,
          paid: {
            count: paidCollections.length,
            amount: totalPaidAmount,
            percentage: collectionsArray.length > 0 ? (paidCollections.length / collectionsArray.length) * 100 : 0
          },
          partiallyPaid: {
            count: partiallyPaidCollections.length,
            amount: totalPartiallyPaidAmount,
            percentage: collectionsArray.length > 0 ? (partiallyPaidCollections.length / collectionsArray.length) * 100 : 0
          },
          pending: {
            count: pendingCollections.length,
            amount: totalPendingAmount,
            percentage: collectionsArray.length > 0 ? (pendingCollections.length / collectionsArray.length) * 100 : 0
          }
        }
      }
    };
  } catch (error) {
    console.error('Error getting collections:', error);
    throw CollectionsService.handleError(error);
  }
}
  /**
   * Process credit payment
   */
  static async processCreditPayment(paymentData) {
    try {
      console.log('Processing payment:', paymentData);
      
      const response = await api.post('/credits/pay-balance', paymentData);
      console.log(paymentData)
      
      // Update collection status if payment successful
      if (response.data.success && paymentData.collectionId) {
        try {
          await CollectionsService.updateStatus(paymentData.collectionId, 'PAID');
          console.log(`Updated collection ${paymentData.collectionId} to PAID`);
        } catch (updateError) {
          console.warn('Status update failed:', updateError);
        }
      }
      
      return response.data;
    } catch (error) {
      console.error('Payment error:', error);
      throw CollectionsService.handleError(error);
    }
  }

  /**
   * Error handling
   */
  static handleError(error) {
    return CollectionsService.handleError(error);
  }
}

export default CreditService;